// ----------------------------------------------------------------------------

function isValidation(arr: any[]): boolean {
    for (const item of arr) {
        if (item.value === '') {
            return false;
        }
    }

    return true;
}

// ----------------------------------------------------------------------------

export default isValidation;
